(function () {
  'use strict';

  // Records that the buyer initiated checkout from one of our cart surfaces
  // (the cart page button, the cart drawer button, or an accelerated/dynamic
  // checkout button). The flag is written to sessionStorage on OUR origin
  // *before* the browser leaves for checkout, so the prohibited shipping-country
  // notice on the cart can be revealed if the buyer is bounced back.
  //
  // Why this exists: the cart used to detect "came from checkout" via
  // document.referrer. When a Cloudflare managed-challenge/interstitial sits
  // between checkout and the cart, the challenge page replaces (or strips) the
  // referrer, so the cart could no longer tell the buyer came from checkout and
  // the banner never showed. sessionStorage is keyed by origin + tab and is
  // retained while the tab lives, so it survives the hop out to checkout, the
  // bounce back, and any same-origin Cloudflare interstitial in between.
  //
  // Read side: assets/cart-prohibited-notice.js (runs on the cart page).
  // Loaded globally from layout/theme.liquid so every checkout entry point is
  // covered, regardless of which page the buyer started from.

  if (window.__pcnIntentBound) return;
  window.__pcnIntentBound = true;

  var KEY = 'pcn_checkout_intent';

  function mark() {
    try {
      sessionStorage.setItem(KEY, String(Date.now()));
    } catch (e) {}
  }

  // Native checkout buttons (cart page + cart drawer) submit a Shopify cart form
  // via a submit button named "checkout" (the "Update" button is named "update",
  // so it won't match). Capture phase so the intent is recorded even if the
  // submit is later cancelled downstream.
  document.addEventListener(
    'submit',
    function (event) {
      var submitter = event.submitter;
      if (submitter && submitter.name === 'checkout') mark();
    },
    true
  );

  // Fallback for browsers without SubmitEvent.submitter and for accelerated /
  // dynamic checkout buttons (Shop Pay, PayPal, ...) rendered in .dynamic-cart-btns.
  // Note: buttons rendered inside a cross-origin iframe (e.g. the Shop Pay button)
  // can't be observed from here — the native checkout button is the primary path.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('[name="checkout"]') || target.closest('.dynamic-cart-btns')) {
        mark();
      }
    },
    true
  );
})();
